import React, { useEffect, useRef, useState } from "react";
import Dashboardmenus from "./Dashboardmenus";
import user from "../../../images/user.png";
import {
  Chart as ChartJS,
  LineElement,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineController,
  BarController,
  PieController,
  Tooltip,
  Legend,
} from "chart.js";
import { authcallApi } from "../../common/API/Api";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../common/formatPrice";
import {
  getServerTime,
  gettimezoneprefrence,
  adjustToTimezone,
  convertToServerTime,
} from "./commonmodal/Getservertime";
import ServerDatePicker from "./commonmodal/ServerDatePicker";
import CommonSpinner from "../../common/CommonSpinner";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { formatName } from "../../common/nameFormatter";
const Analytics = () => {
  const { t } = useTranslation();
  ChartJS.register(
    LineElement,
    BarElement,
    ArcElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineController,
    BarController,
    PieController,
    Tooltip,
    Legend,
  );
  const dropdownRef = useRef(null);
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();
  const [startDate, setStartDate] = useState("");
  const [startMonthOffset, setStartMonthOffset] = useState(-1);
  const [endDate, setEndDate] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [profitabilityData, setProfitabilityData] = useState([]);
  const [tradeAmountsData, setTradeAmountsData] = useState();
  const [assetsDistributionData, setAssetsDistributionData] = useState([]);
  const [tradesummary, setTradesummary] = useState();
  const [userDetails, setUserDetails] = useState(null);
  const [loadingdata, setLoadingdata] = useState({
    Trade_Summary: true,
    Trades_Distribution_by_Assets: true,
    Profitability: true,
    Trade_Amounts_by_Assets: true,
  });

  const fetchServerTime = async () => {
    const data = await getServerTime();
    const timezonePref = await gettimezoneprefrence();

    if (data?.success) {
      const adjustedTimestamp = await adjustToTimezone(
        data.server_time,
        timezonePref.time,
      );

      return {
        ...data,
        adjustedTimestamp,
        timezonePref,
      };
    }
    return data;
  };
  useEffect(() => {
    fetchServerTime();
  }, []);
  const handleDateChange = async (start, end) => {
    const timezonePref = await gettimezoneprefrence();
    let updatedstart = start ? convertToServerTime(start, timezonePref.time) : "";
    let updatedend = convertToServerTime(end, timezonePref.time);
    setEndDate(updatedend);
    setStartDate(updatedstart);
  };
  const getProfitability = async () => {
    try {
     
      setLoadingdata((state) => ({
        ...state,
        Profitability: true,
      }));
      let postdata = {};
      let start_date = startDate;
      let end_date = endDate;
      let res = await authcallApi(
        postdata,
        `api/profitchart?startDate=${start_date}&endDate=${end_date}`,
      );
      if (res?.data?.success) {
        if (res?.data?.data?.length) {
          const timezonePref = await gettimezoneprefrence();

          const updatedata = res.data.data.map((item) => {
            const adjustedTime = adjustToTimezone(item[0], timezonePref.time);
            return [adjustedTime, item[1]];
          });
          setProfitabilityData(updatedata);
        }
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdata((state) => ({
        ...state,
        Profitability: false,
      }));
    }
  };
  const gettradechart = async () => {
    try {
      setLoadingdata((state) => ({
        ...state,
        Trade_Amounts_by_Assets: true,
      }));
      let postdata = {};
      let start_date = startDate;
      let end_date = endDate;
      let res = await authcallApi(
        postdata,
        `api/tradechart?startDate=${start_date}&endDate=${end_date}`,
      );
      if (res?.data?.success) {
        const apidata = {
          categories: res?.data?.categories,
          series: res?.data?.series,
        };
        setTradeAmountsData(apidata);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdata((state) => ({
        ...state,
        Trade_Amounts_by_Assets: false,
      }));
    }
  };
  const gettradechartper = async () => {
    try {
      setLoadingdata((state) => ({
        ...state,
        Trades_Distribution_by_Assets: true,
      }));
      let postdata = {};
      let start_date = startDate;
      let end_date = endDate;
      let res = await authcallApi(
        postdata,
        `api/tradechartper?startDate=${start_date}&endDate=${end_date}`,
      );
      if (res?.data?.success) {
        const input = res?.data;
        const apidata = input.labels.map((label, index) => ({
          name: label,
          y: input.data[index],
        }));
        setAssetsDistributionData(apidata);
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdata((state) => ({
        ...state,
        Trades_Distribution_by_Assets: false,
      }));
    }
  };
  const gettradesummary = async (filter, filterid) => {
    try {
      setLoadingdata((state) => ({
        ...state,
        Trade_Summary: true,
      }));
      let postdata = {};
      let start_date = startDate;
      let end_date = endDate;
      let res = await authcallApi(
        postdata,
        `api/leaderboardreport?startDate=${start_date}&endDate=${end_date}`,
        "GET",
      );
      if (res?.data?.success) {
        setTradesummary({
          ...res?.data?.trade,
          filterid: filterid ? filterid : "today-tab",
          filter: filter,
        });
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setLoadingdata((state) => ({
        ...state,
        Trade_Summary: false,
      }));
    }
  };
  const userdetails = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(postdata, `api/userdetail?type=real`, "GET");
      if (res?.data?.success) {
        setUserDetails(res?.data?.data?.user);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    if (endDate || startDate) {
      getProfitability();
      gettradechart();
      gettradechartper();
      gettradesummary();
      userdetails();
    }
  }, [startDate, endDate]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const optionsforprofit = {
    chart: {
      type: "areaspline",
      backgroundColor: "transparent",
      height: 500,
      zooming: { type: "x" },
    },
    title: {
      text: null,
      align: "left",
      style: { fontSize: "16px", fontWeight: "bold", color: "#fff" },
    },
    xAxis: {
      type: "datetime",
      labels: {
        formatter: function () {
          const chart = this.axis.chart;
          const index = this.axis.tickPositions.indexOf(this.value);
          const currentDate = Highcharts.dateFormat("%Y-%m-%d", this.value);
          const prevValue = this.axis.tickPositions[index - 1];
          const prevDate = prevValue
            ? Highcharts.dateFormat("%Y-%m-%d", prevValue)
            : null;
          if (!prevDate || currentDate !== prevDate) {
            return Highcharts.dateFormat("%b %e", this.value);
          } else {
            return Highcharts.dateFormat("%I:%M %p", this.value);
          }
        },
        style: { color: "#fff" },
      },
      lineWidth: 0,
      tickLength: 0,
      gridLineWidth: 0,
    },
    yAxis: {
      title: { text: null },
      gridLineWidth: 0,
      lineWidth: 0,
      labels: { style: { color: "#fff" } },
    },
    tooltip: {
      xDateFormat: "%a, %e %b, %I:%M %p",
      valueDecimals: 2,
      valuePrefix: "$",
      shared: true,
    },
    legend: { enabled: false },
    plotOptions: {
      areaspline: {
        lineWidth: 2,
        color: "#3fa9f5",
        fillOpacity: 0,
        shadow: {
          color: "rgba(63, 169, 245, 0.5)",
          width: 8,
          offsetX: 0,
          offsetY: 6,
        },
        marker: {
          radius: 0,
          symbol: "circle",
        },
      },
    },
    series: [
      {
        name: "Profit",
        data: profitabilityData,
      },
    ],

    credits: { enabled: false },
  };

  const optionsfortradedistributipon = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      // height: 500,
      // width: 400,
    },
    title: {
      text: null,
      align: "left",
      style: {
        color: "#d9d9d9",
        fontSize: "16px",
        fontWeight: "500",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
      backgroundColor: "#1b1f33",
      borderColor: "#2a2f45",
      style: { color: "#fff" },
    },
    plotOptions: {
      pie: {
        innerSize: "60%",
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          distance: 15,
          style: {
            color: "#d9d9d9",
            textOutline: "none",
            fontSize: "11px",
          },
          connectorColor: "#4a4f68",
        },
      },
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: "Trades",
        colorByPoint: true,
        data: assetsDistributionData,
      },
    ],
    credits: {
      enabled: false,
    },
  };
  const optionsforprofitloss = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
    },

    title: {
      text: "",
    },

    xAxis: {
      categories: tradeAmountsData?.categories,
      labels: {
        rotation: -45,
        style: {
          color: "#ffffff",
        },
      },
      lineColor: "#444",
      tickColor: "#444",
    },

    yAxis: {
      title: { text: "" },
      gridLineColor: "rgba(255,255,255,0.1)",
      labels: {
        style: { color: "#fff" },
      },
    },

    legend: {
      enabled: true,
      itemStyle: { color: "#fff" },
    },

    tooltip: {
      shared: true,
      backgroundColor: "#000",
      style: { color: "#fff" },
    },

    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },

    series: tradeAmountsData?.series,
    credits: {
      enabled: false,
    },
  };
  return (
    <React.Fragment>
      <Dashboardmenus />
      <div className="dashboard-contentbody">
        <section className="DepositSec">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="analyticsrow">
                  <div className="row">
                    {/* <!-- Sidebar Profile Section --> */}
                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4">
                      <div className="cardBox profile-card text-center p-3 mb-4">
                        <img
                          style={{
                            height: "120px",
                            objectFit: "cover",
                          }}
                          src={
                            userDetails?.image
                              ? process.env.REACT_APP_IMAGE_URL +
                                userDetails?.image
                              : user
                          }
                          className="rounded-circle mb-3"
                          alt=""
                        />
                        <h4>{formatName(userDetails?.name)}</h4>
                        <p className="text-muted real-account">
                          {t("Real Account Statistics")}
                        </p>
                        <div className="trq">
                          <p>
                            <span>UID:</span> {userDetails?.id}
                          </p>
                          <p>
                            Balance:{" "}
                            <strong>
                              ${formatPrice(userDetails?.balance, 2)}
                            </strong>
                          </p>
                        </div>
                      </div>

                      {/* <!-- Trading Stats Summary with Tabs --> */}
                      <div className="cardBox p-3 rteq mb-4">
                        <h5 className="card_title">Trade Summary</h5>
                        <ServerDatePicker
                          fetchServerTime={fetchServerTime}
                          onChange={handleDateChange}
                          type={"tradesummery"}
                        />

                        <div className="tradeSummaryfilminh">
                          <div className="tab-content">
                            {loadingdata?.Trade_Summary ? (
                              <CommonSpinner />
                            ) : (
                              <div
                                className={`trade-data tradeSummary tradeSummary-alert`}
                              >
                                <div
                                  className={`alert ${
                                    tradesummary?.trades_count !== 0
                                      ? "alert-success"
                                      : "alert-secondary"
                                  }`}
                                >
                                  Trades:{" "}
                                  <span>{tradesummary?.trades_count ?? 0}</span>
                                </div>

                                <div
                                  className={`alert ${
                                    tradesummary?.profitable_trades === 0
                                      ? "alert-secondary"
                                      : tradesummary?.profitable_trades < 0
                                        ? "alert-danger"
                                        : tradesummary?.profitable_trades < 30
                                          ? "alert-danger"
                                          : tradesummary?.profitable_trades < 70
                                            ? "alert-warning"
                                            : "alert-success"
                                  }`}
                                >
                                  {t("Profitable Trades")}:{" "}
                                  <span>
                                    {tradesummary?.profitable_trades ?? 0}%
                                  </span>
                                </div>

                                <div
                                  className={`alert ${
                                    tradesummary?.trading_turnover !== 0
                                      ? "alert-success"
                                      : "alert-secondary"
                                  }`}
                                >
                                  {t("Trading turnover:")}{" "}
                                  <span>
                                    $
                                    {formatPrice(
                                      tradesummary?.trading_turnover,
                                      2,
                                    ) ?? 0}
                                  </span>
                                </div>

                                <div
                                  className={`alert ${
                                    tradesummary?.net_turnover !== 0
                                      ? "alert-success"
                                      : "alert-secondary"
                                  }`}
                                >
                                  {t("Net turnover:")}{" "}
                                  <span>
                                    $
                                    {formatPrice(
                                      tradesummary?.net_turnover,
                                      2,
                                    ) ?? 0}
                                  </span>
                                </div>

                                <div
                                  className={`alert ${
                                    tradesummary?.trades_profit === 0
                                      ? "alert-secondary"
                                      : tradesummary?.trades_profit > 0
                                        ? "alert-success"
                                        : "alert-danger"
                                  }`}
                                >
                                  {t("Trading profit:")}{" "}
                                  <span>
                                    $
                                    {formatPrice(
                                      tradesummary?.trades_profit,
                                      2,
                                    ) ?? 0}
                                  </span>
                                </div>

                                <div
                                  className={`alert ${
                                    tradesummary?.max_trade_amount !== 0
                                      ? "alert-success"
                                      : "alert-secondary"
                                  }`}
                                >
                                  {t("Max Trade")}:{" "}
                                  <span>
                                    $
                                    {formatPrice(
                                      tradesummary?.max_trade_amount,
                                      2,
                                    ) ?? 0}
                                  </span>
                                </div>

                                <div
                                  className={`alert ${
                                    tradesummary?.min_trade_amount !== 0
                                      ? "alert-success"
                                      : "alert-secondary"
                                  }`}
                                >
                                  {t("Min Trade")}:{" "}
                                  <span>
                                    $
                                    {formatPrice(
                                      tradesummary?.min_trade_amount,
                                      2,
                                    ) ?? 0}
                                  </span>
                                </div>

                                <div
                                  className={`alert ${
                                    tradesummary?.max_profit === 0
                                      ? "alert-secondary"
                                      : tradesummary?.max_profit > 0
                                        ? "alert-success"
                                        : "alert-danger"
                                  }`}
                                >
                                  {t("Max Profit")}:{" "}
                                  <span>
                                    $
                                    {formatPrice(tradesummary?.max_profit, 2) ??
                                      0}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- Charts Section --> */}
                    <div className="col-xl-8 col-lg-8 col-md-6 col-sm-12">
                      <div className="cardBox p-4 cardProfitability mb-4">
                        <h4 className="card_title text-center">
                          {t("Profitability")}
                        </h4>
                        {/* <HighchartsReact highcharts={Highcharts} options={optionsforprofit} /> */}
                        {loadingdata?.Profitability ? (
                          <CommonSpinner />
                        ) : profitabilityData?.length ? (
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={optionsforprofit}
                          />
                        ) : (
                          <div className="text-center text-white NotradingHistory">
                            <span>
                              Profitability
                              <br />
                              <small>No trading history</small>
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="cardBox p-4 cardTradesDistributionAssets mb-4">
                        <h4 className="card_title text-center">
                          {t("Trades Distribution by Assets")}
                        </h4>

                        {loadingdata?.Trades_Distribution_by_Assets ? (
                          <CommonSpinner />
                        ) : assetsDistributionData?.length ? (
                          // assetsDistributionData ? (
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={optionsfortradedistributipon}
                          />
                        ) : (
                          <div className="text-center text-white NotradingHistory">
                            <span>
                              Trades Distribution by Assets
                              <br />
                              <small>No trading history</small>
                            </span>
                          </div>
                        )}
                      </div>
                      <div className="cardBox p-4 cardTradeAmountsAssets mb-4">
                        <h4 className="card_title text-center">
                          Trades number
                        </h4>
                        {loadingdata?.Trade_Amounts_by_Assets ? (
                          <CommonSpinner />
                        ) : tradeAmountsData?.categories?.length ? (
                          tradeAmountsData ? (
                            // <Bar
                            //   data={tradeAmountsData}
                            //   options={{
                            //     scales: { y: { beginAtZero: true } },
                            //   }}
                            // />
                            <HighchartsReact
                              highcharts={Highcharts}
                              options={optionsforprofitloss}
                            />
                          ) : (
                            ""
                          )
                        ) : (
                          <div className="text-center text-white NotradingHistory">
                            <span>
                              Trade Amounts by Assets
                              <br />
                              <small>No trading history</small>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
};

export default Analytics;
